// NotificationToaster.js
import React from "react"
import { Col, Row, Toast, ToastContainer } from "react-bootstrap"
import { useNotifications } from "./NotificationContext"

const NotificationToaster = () => {
  const { notifications, removeNotification } = useNotifications()

  return (
    <ToastContainer position="top-end" className="p-3 text-end">
      {notifications.map((notification, index) => (
        <span key={index}>
          <Toast
            onClose={() => removeNotification(index)}
            delay={notification.delay != null ? notification.delay : 1500}
            autohide
            bg={notification.variant != null ? notification.variant : "success"}
            text="white"
          >
            {notification.title !== undefined ? (
              <Toast.Header>
                <strong className="me-auto">{notification.title}</strong>
              </Toast.Header>
            ) : (
              ""
            )}

            <Toast.Body className="text-white">
              {notification.message !== "" ? (
                <Row>
                  <Col md={1} className="text-center">
                    {notification.icon}
                  </Col>
                  {notification.message && (
                    <Col md={11} className="text-end">
                      {notification.message}
                    </Col>
                  )}
                </Row>
              ) : (
                ""
              )}
            </Toast.Body>
          </Toast>
          <br />
        </span>
      ))}
    </ToastContainer>
  )
}

export default NotificationToaster
